import React from 'react'
import "./navbar.css";
import axios from 'axios';
import { useEffect, useState } from 'react';
import { FaFacebookF, FaInstagram, FaYoutube, FaLinkedinIn } from "react-icons/fa";
import Logo2 from "../../assets/audio/images/kwtlogo4.png"
import Logo22 from "../../assets/audio/images/logo421.png"
import logoWeb from "../../assets/audio/images/Web Logo.png"
import logoWeb1 from "../../assets/audio/images/Web Logo1.png"
import Logo3 from "../../assets/audio/images/kwtlogo2.png"
import { Link } from 'react-router-dom';
import HomeIcon from '@mui/icons-material/Home';
import VideoLibrary from '@mui/icons-material/VideoLibrary';
import BuildOutlinedIcon from '@mui/icons-material/BuildOutlined';
import CampaignOutlinedIcon from '@mui/icons-material/CampaignOutlined';
import TimelineOutlinedIcon from '@mui/icons-material/TimelineOutlined';
import NewspaperOutlinedIcon from '@mui/icons-material/NewspaperOutlined';
import HandshakeOutlinedIcon from '@mui/icons-material/HandshakeOutlined';
import InfoIcon from '@mui/icons-material/Info';
import { Button } from '@mui/material';

const topbarSocialLinks = [
  { href: "https://www.facebook.com/KhadijaWelfareTrust", icon: FaFacebookF, label: "Facebook" },
  { href: "https://www.instagram.com/khadijatulkubrawelfare", icon: FaInstagram, label: "Instagram" },
  { href: "https://www.youtube.com/@khadijawelfareofficial", icon: FaYoutube, label: "YouTube" },
  { href: "https://www.linkedin.com/company/khadija-tul-kubra-welfare-trust", icon: FaLinkedinIn, label: "LinkedIn" },
];

const NavbarAll = () => {
    const [preloaderVisible, setPreloaderVisible] = useState(true);

    const handleMenuBtnClick = () => {
        const menu = document.querySelector('.rsnp-mnu');
        menu.classList.add('slidein');
      };
    
      const handleMenuCloseClick = () => {
        const menu = document.querySelector('.rsnp-mnu');
        menu.classList.remove('slidein');
      };
    
      const handleMenuItemClick = (event) => {
        const menuItem = event.currentTarget.parentElement;
        const siblings = Array.from(menuItem.parentNode.children).filter((child) => child !== menuItem);
      
        siblings.forEach((sibling) => {
          const ul = sibling.querySelector('ul');
          if (ul) {
            ul.style.display = 'none';
          }
          sibling.classList.remove('active');
        });
      
        const childUl = menuItem.querySelector('ul');
        if (childUl) {
          if (childUl.style.display === 'block') {
            childUl.style.display = 'none';
          } else {
            childUl.style.display = 'block';
          }
        }
      
        menuItem.classList.toggle('active');
      };
    
  
      const [sunriseTime, setSunriseTime] = useState('');
      const [sunsetTime, setSunsetTime] = useState('');
    
      useEffect(() => {
        const currentDate = new Date().toISOString().split('T')[0];
        const apiUrl = `https://api.sunrisesunset.io/json?lat=24.9331712&lng=67.1055872&date=${currentDate}`;
        try {
          setPreloaderVisible(false);
        } catch (error) {
          setPreloaderVisible(false);
        }
        
        // Fetch sunrise and sunset times
        axios.get(apiUrl)
          .then(response => {
            const { sunrise, sunset } = response.data.results;
            setSunriseTime(sunrise);
            setSunsetTime(sunset);
          })
          .catch(error => {
            console.error('Error fetching sunrise and sunset data:', error);
          });
      }, []);
    const handleLinkClick = () => {
      
        window.scrollTo(0, 0);
      };
  return (
    <>
    {preloaderVisible && (
         <div id="preloader">            
                <div class="preloader-inner">
                    <i class="preloader-icon thm-clr flaticon-kaaba"></i>
                </div>
            </div>
             )}
            <header class="stick style2 w-100" >
        
             <div className="topbar w-100" style={{ backgroundColor: "#011a4c", padding: "8px 0" }}>
  <div className="container">
    <div className="topbar-inner d-flex justify-content-between align-items-center" style={{ flexWrap: "nowrap", gap: "8px", minWidth: 0 }}>
      
      {/* Left Side: Social, Email & Phone */}
      <div className="d-flex align-items-center" style={{ color: "white", gap: "12px", flexWrap: "nowrap", minWidth: 0, flexShrink: 1, overflow: "hidden" }}>
        <div className="d-flex align-items-center" style={{ gap: "6px", flexShrink: 0 }}>
          {topbarSocialLinks.map(({ href, icon: Icon, label }) => (
            <a
              key={label}
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={label}
              style={{
                width: "26px",
                height: "26px",
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "50%",
                background: "rgba(255,255,255,0.15)",
                color: "#fff",
                textDecoration: "none",
                transition: "background 0.3s, transform 0.2s",
                flexShrink: 0,
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = "rgba(255,255,255,0.3)";
                e.currentTarget.style.transform = "translateY(-2px)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = "rgba(255,255,255,0.15)";
                e.currentTarget.style.transform = "translateY(0)";
              }}
            >
              <Icon style={{ width: "13px", height: "13px" }} />
            </a>
          ))}
        </div>
        <span style={{ flexShrink: 0, fontSize: "13px", whiteSpace: "nowrap" }}>
          <i className="fas fa-envelope"></i> info@khadijahwelfare.org
        </span>
        <span style={{ flexShrink: 0, fontSize: "13px", whiteSpace: "nowrap" }}>
          <i className="fas fa-phone"></i> +92 313 1279895
        </span>
      </div>

      {/* Right Side: Sunrise, Sunset & Donate - single line */}
      <div className="d-flex align-items-center" style={{ gap: "8px", flexWrap: "nowrap", flexShrink: 0 }}>
        <span style={{ color: "white", fontSize: "13px", whiteSpace: "nowrap" }}>
          <i className="thm-clr flaticon-sun" style={{ color: "yellow", marginRight: "4px" }}></i>
          {sunriseTime}
        </span>
        <span style={{ color: "rgba(255,255,255,0.6)", fontSize: "12px" }}>|</span>
        <span style={{ color: "white", fontSize: "13px", whiteSpace: "nowrap" }}>
          <i className="thm-clr flaticon-moon" style={{ color: "lightblue", marginRight: "4px" }}></i>
          {sunsetTime}
        </span>
        <Button
          variant="contained"
          sx={{
            backgroundColor: "#f87901",
            color: "#fff",
            fontWeight: "bold",
            textTransform: "none",
            padding: "5px 12px",
            fontSize: "0.85rem",
            borderRadius: "6px",
            boxShadow: "0 2px 6px rgba(255, 0, 0, 0.15)",
            flexShrink: 0,
            minWidth: "auto",
            "&:hover": { backgroundColor: "#d08c04" },
          }}
          onClick={() => window.location.href = "/donate"}
        >
          Donate Now
        </Button>
      </div>
    </div>
  </div>
</div>


                <div class="logo-menu-wrap v2 d-flex flex-wrap align-items-center justify-content-between w-100 pat-bg back-blend-multiply" style={{backgroundColor:"#fff"}}  >
                    <div style={{backgroundColor:"#fff"}} class="logo text-center thm-bg"><h1 class="mb-0"><Link to="/" title="Home"><img class="img-fluid" src={Logo2} alt="Logo" srcset={Logo2}/></Link></h1></div>
                    <div class="container"  >
                        <nav class="d-flex flex-wrap align-items-center justify-content-end">
                            <div class="header-left">
                            <ul class="mb-0 list-unstyled d-inline-flex">
                                <li ><Link style={{color:'#03193c'}} to="/" title="" onClick={handleLinkClick}>Home</Link>
                                    </li>
                                    
                                    <li style={{color:'#03193c'}} className=""><Link to="/about" title="">About Us</Link>
                                        
                                    </li>
                                    <li className="menu-item">
  <Link to="/services" title="" style={{ color: "#03193c" }}>
    Our Projects
  </Link>
  
</li>
                                    <li style={{color:'#03193c'}}><Link to="/timeline" title="" onClick={handleLinkClick}>Timeline</Link></li>
                                    <li style={{color:'#03193c'}}><Link to="/news" title="" onClick={handleLinkClick}>Upcoming Events</Link></li>

                                     <li>
  <Link to="/donate" title="" style={{ color: "#03193c" }}>
    Donate
  </Link>

</li>
                                    <li style={{color:'#03193c'}}><Link to="/hazrat" title="">Bayanat</Link>
                                        
                                       
                                    </li>
                                    {/* <li className="/blog"><Link to="/blog" title="">Blog</Link>
                                    </li> */}
                                   
                                </ul>
                            </div>
                            
                        </nav>
                    </div>
                </div>
            </header>
            <div class="sticky-menu">
                <div class="container">
                    <div class="sticky-menu-inner d-flex flex-wrap align-items-center justify-content-between w-100">
                        <div class="logo"><h1 class="mb-0"><Link to="/" title="Home"><img class="img-fluid" src={logoWeb1} alt="Logo" srcset={logoWeb1}/></Link></h1></div>
                        <nav class="d-flex flex-wrap align-items-center justify-content-between">
                            <div class="header-left">
                            <ul class="mb-0 list-unstyled d-inline-flex">
                            <li ><Link  to="/" title="" onClick={handleLinkClick}>Home</Link>
                                    </li>
                                    <li  className=""><Link to="/about" title="">About Us</Link>
                                      
                                    </li>
                                    <li className="menu-item">
  <Link to="/services" title="" >
    Our Projects
  </Link>
  
</li>
                                    <li><Link to="/timeline" title="" onClick={handleLinkClick}>Timeline</Link></li>
                                    <li><Link to="/" title="" onClick={handleLinkClick}>Upcoming Events</Link></li>

                                     <li>
  <Link to="/donate" title="" style={{ color: "#03193c" }}>
    Donate
  </Link>
</li>
                                    <li ><Link to="/hazrat" title="">Bayanat</Link>
                                    </li>
                                </ul>
                            </div>
                        </nav>
                    </div>
                </div>
            </div>
            <div class="rspn-hdr" style={{backgroundColor:"white"}}>
               <div
  style={{
    height: "40px",
    backgroundColor: "#ff4500",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
    fontWeight: "bold",
    color: "white",
    fontSize: "14px",
    border: "none",
  }}
  onClick={() => window.location.href = "/donate"} // change link as needed
>
  Donate Now
</div>

                <div class="rspn-mdbr1" style={{ height: "40px", padding: "0 15px" ,backgroundColor:"#041562", color: "white" }}>
  <div
    class="rspn-scil"
    style={{
      fontSize: "14px",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      color: "peachpuff",
    }}
  >
    <span style={{color:'white', marginRight:"15px"}}>
      <i className="fas fa-envelope" style={{ marginRight: "5px", color: "white" }}></i>
      info@khadijahwelfare.org
    </span>
    <span style={{color:'white'}}>
      <i className="fas fa-phone" style={{ marginRight: "5px", color: "white" }}></i>
      +92 313 1279895
    </span>
  </div>
</div>

                <div class="lg-mn">
                    <div class="logo"><Link to="/" title="Home" onClick={handleLinkClick}><img src={logoWeb} alt="Logo"/></Link></div>
                    <div class="rspn-cnt">
                        <span><i class="thm-clr far fa-envelope"></i><Link to=" " title="">info@youremailid.com</Link></span>
                        <span><i class="thm-clr fas fa-phone-alt"></i>+96 125 554 24 5</span>
                    </div>
                    <span class="rspn-mnu-btn" onClick={handleMenuBtnClick}><i class="fa fa-list-ul"  onClick={handleMenuBtnClick}></i></span>
                </div>
                <div class="rsnp-mnu">
                    <span class="rspn-mnu-cls" onClick={handleMenuCloseClick}><i class="fa fa-times" onClick={handleMenuCloseClick}></i></span>
                    <ul class="mb-0 list-unstyled w-100">
                                <li><Link to="/" title="Home" onClick={handleLinkClick}>
                                <HomeIcon style={{ marginRight: '8px', verticalAlign: 'middle', marginBottom:"5px" }} />
                                Home</Link>
                                </li>
                                    <li className=""><Link to="/about" title="" onClick={handleMenuItemClick}>
                                    <InfoIcon style={{marginRight:"8px", verticalAlign:"middle",marginBottom: "4px"}} />
                                    About Us</Link>
                                       
                                    </li>
                                    <li className="menu-item">
  <Link to="/services" title="" onClick={handleMenuItemClick}>
    <BuildOutlinedIcon style={{ marginRight: "8px", verticalAlign: "middle", marginBottom: "7px" }} />
    Our Projects
  </Link>
  <ul className="mb-0 list-unstyled">


                                        </ul>
</li>
<li>
  <Link to="/timeline" title="" onClick={handleLinkClick}>
    <TimelineOutlinedIcon style={{ marginRight: "8px", verticalAlign: "middle", marginBottom: "7px" }} />
    Timeline
  </Link>
</li>
<li>
  <Link to="/news" title="" onClick={handleLinkClick}>
    <NewspaperOutlinedIcon style={{ marginRight: "8px", verticalAlign: "middle", marginBottom: "7px" }} />
    Upcoming Events
  </Link>
</li>
<li >
  <Link to="/donate" title="" onClick={handleMenuItemClick}>
    <HandshakeOutlinedIcon style={{ marginRight: "8px", verticalAlign: "middle", marginBottom: "7px" }} />
    Donate
  </Link>

</li>
<li ><Link to="/hazrat" title="" onClick={handleMenuItemClick}>
                                    <VideoLibrary style={{marginRight:"8px", verticalAlign:"middle"}}/>
                                    Bayanat</Link>
                                    </li>              
                    </ul>
                </div>
            </div>
            
           
           
    </>
       
     
  )
}

export default NavbarAll
